/* tslint:disable */
/* eslint-disable */
/**
 * Melco ControlCenter APIs
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ControlcenterMelcoModelsCouponListItem
 */
export interface ControlcenterMelcoModelsCouponListItem {
    /**
     * 
     * @type {string}
     * @memberof ControlcenterMelcoModelsCouponListItem
     */
    id?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ControlcenterMelcoModelsCouponListItem
     */
    code?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ControlcenterMelcoModelsCouponListItem
     */
    description?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ControlcenterMelcoModelsCouponListItem
     */
    type?: number;
    /**
     * 
     * @type {number}
     * @memberof ControlcenterMelcoModelsCouponListItem
     */
    value?: number;
    /**
     * 
     * @type {number}
     * @memberof ControlcenterMelcoModelsCouponListItem
     */
    user_id?: number;
    /**
     * 
     * @type {string}
     * @memberof ControlcenterMelcoModelsCouponListItem
     */
    product_code?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ControlcenterMelcoModelsCouponListItem
     */
    usage_count?: number;
    /**
     * 
     * @type {number}
     * @memberof ControlcenterMelcoModelsCouponListItem
     */
    usage_type?: number;
    /**
     * 
     * @type {boolean}
     * @memberof ControlcenterMelcoModelsCouponListItem
     */
    is_active?: boolean;
    /**
     * 
     * @type {Date}
     * @memberof ControlcenterMelcoModelsCouponListItem
     */
    created_date?: Date;
    /**
     * 
     * @type {Date}
     * @memberof ControlcenterMelcoModelsCouponListItem
     */
    start_date?: Date;
    /**
     * 
     * @type {Date}
     * @memberof ControlcenterMelcoModelsCouponListItem
     */
    end_date?: Date | null;
    /**
     * 
     * @type {string}
     * @memberof ControlcenterMelcoModelsCouponListItem
     */
    history?: string | null;
    /**
     * 
     * @type {Date}
     * @memberof ControlcenterMelcoModelsCouponListItem
     */
    deactivated_on?: Date | null;
}

export function ControlcenterMelcoModelsCouponListItemFromJSON(json: any): ControlcenterMelcoModelsCouponListItem {
    return ControlcenterMelcoModelsCouponListItemFromJSONTyped(json, false);
}

export function ControlcenterMelcoModelsCouponListItemFromJSONTyped(json: any, ignoreDiscriminator: boolean): ControlcenterMelcoModelsCouponListItem {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'code': !exists(json, 'code') ? undefined : json['code'],
        'description': !exists(json, 'description') ? undefined : json['description'],
        'type': !exists(json, 'type') ? undefined : json['type'],
        'value': !exists(json, 'value') ? undefined : json['value'],
        'user_id': !exists(json, 'user_id') ? undefined : json['user_id'],
        'product_code': !exists(json, 'product_code') ? undefined : json['product_code'],
        'usage_count': !exists(json, 'usage_count') ? undefined : json['usage_count'],
        'usage_type': !exists(json, 'usage_type') ? undefined : json['usage_type'],
        'is_active': !exists(json, 'is_active') ? undefined : json['is_active'],
        'created_date': !exists(json, 'created_date') ? undefined : (new Date(json['created_date'])),
        'start_date': !exists(json, 'start_date') ? undefined : (new Date(json['start_date'])),
        'end_date': !exists(json, 'end_date') ? undefined : (json['end_date'] === null ? null : new Date(json['end_date'])),
        'history': !exists(json, 'history') ? undefined : json['history'],
        'deactivated_on': !exists(json, 'deactivated_on') ? undefined : (json['deactivated_on'] === null ? null : new Date(json['deactivated_on'])),
    };
}

export function ControlcenterMelcoModelsCouponListItemToJSON(value?: ControlcenterMelcoModelsCouponListItem | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'code': value.code,
        'description': value.description,
        'type': value.type,
        'value': value.value,
        'user_id': value.user_id,
        'product_code': value.product_code,
        'usage_count': value.usage_count,
        'usage_type': value.usage_type,
        'is_active': value.is_active,
        'created_date': value.created_date === undefined ? undefined : (value.created_date.toISOString()),
        'start_date': value.start_date === undefined ? undefined : (value.start_date.toISOString()),
        'end_date': value.end_date === undefined ? undefined : (value.end_date === null ? null : value.end_date.toISOString()),
        'history': value.history,
        'deactivated_on': value.deactivated_on === undefined ? undefined : (value.deactivated_on === null ? null : value.deactivated_on.toISOString()),
    };
}


